import React, { useEffect, useState } from 'react';
import './applicationsStyle.css';
import H2Title from './../../../../components/text/h2Title/h2Title'
import ApplicationCard from './applicationCard/applicationCard';

export default function Applications({applications, title}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    };

    useEffect( () => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    return (
        <section className='applications__container'>
            <div className='applications__text-container'>
                <H2Title title={title} color={"white"} width={(windowWidth < 769) ? "100%" : "min-content"}/>
                
                <div className='applications__list'>
                    {applications?.map( (application, index) => (
                        <>
                        {application?.title && <ApplicationCard application={application} key={index}/>}
                        </>
                    ))}
                </div>
            </div>
        </section>
    );
}
